import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal({ isOpen, onClose, children }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal content */}
      <div className="relative z-50 bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-4xl max-h-[90vh] w-full m-4 transition-colors duration-200">
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 bg-white dark:bg-gray-700 rounded-full p-1 shadow-md hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-200"
        >
          <X className="w-5 h-5 dark:text-gray-200" />
        </button>
        
        <div className="p-4 overflow-auto dark:text-gray-200">
          {children}
        </div>
      </div>
    </div>
  );
}
